export const INDIA_API_BASE_URL = "https://live.ohyesworld.com";
// export const US_API_BASE_URL = "https://us.staging.ohyesworld.com";
export const US_API_BASE_URL = "https://us.live.ohyesworld.com";

const isTruthyFlag = (value) =>
  value === true || value === "true" || value === "1";

export const isUSUser = () => {
  try {
    const userCountry = localStorage.getItem("userCountry");
    const isUSFlag = localStorage.getItem("isUS");
    const isUSRoute =
      typeof window !== "undefined" && window.location.pathname.startsWith("/us");

    return userCountry === "US" || isTruthyFlag(isUSFlag) || isUSRoute;
  } catch (error) {
    // Ignore storage access errors and fall back to route-based check or India API
    return typeof window !== "undefined" && window.location.pathname.startsWith("/us");
  }
};

export const getApiBaseUrl = () =>
  isUSUser() ? US_API_BASE_URL : INDIA_API_BASE_URL;
